import { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import ModalFiltersNewRemittance from './ModalFiltersNewRemittance'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { PaymentTypesPayload } from '../../../../../../../../utils/reducers/payments/paymentTypes'
import { PaymentMethodsPayload } from '../../../../../../../../utils/reducers/payments/paymentMethods'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import ModalSelectNewRemittance from './ModalSelectNewRemittance'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'


type ModalNewRemittanceProps  = ReduxModalNewRemittance & ModalEditComponentProps & {}

const ModalNewRemittance: React.FC<ModalNewRemittanceProps> = ({ paymentTypes, paymentMethods, workingCenters, setOpened, onSubmit}) => {
    const { preSearchFilters, setPreSearchFilters } = useModalNewRemittanceLogic()
    if (preSearchFilters === null){
        return <ModalFiltersNewRemittance {...{ paymentTypes, paymentMethods, setOpened, preSearchFilters, setPreSearchFilters}}/>
    }
    return (
        <ModalSelectNewRemittance {...{ setOpened, onSubmit, setPreSearchFilters, workingCenters, paymentTypes, paymentMethods, preSearchFilters }} />
    )
}

const useModalNewRemittanceLogic = () => {
    const [preSearchFilters, setPreSearchFilters] = useState<TwinDictionary | null>(null)

    return { preSearchFilters, setPreSearchFilters }
}


const modalNewRemittanceDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
    setPaymentMethods: (payload: PaymentMethodsPayload) => ({ type: 'CHANGE_PAYMENTMETHODS', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

type ReduxModalNewRemittance = ConnectedProps<typeof modalNewRemittanceConnect>
const mapModalNewRemittanceConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes, paymentMethods: state.paymentMethods, workingCenters: state.workingCenters })
const modalNewRemittanceConnect = connect(mapModalNewRemittanceConnector, modalNewRemittanceDispatch)
const modalNewRemittanceConnectLoading = withLoading(ModalNewRemittance, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }, { fetchUrl: '/api/app/config/payment/paymentMethod/getAllPaymentMethods', propName: 'paymentMethods', setFunctionName: 'setPaymentMethods' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalNewRemittanceConnect = modalNewRemittanceConnect(modalNewRemittanceConnectLoading)


export default ModalNewRemittanceConnect